export default __webpack_public_path__ + "static/media/rug14-min.616590f8.jpg";